import React from 'react';
import { SharedNavbar } from '../components/SharedNavbar';
import { Footer } from '../components/Footer';
import { FadeIn } from '../components/FadeIn';
import { MessageCircle, Mail, MapPin, Clock, AlertCircle, Phone } from 'lucide-react';
export function ContactPage() {
  const whatsappLink = 'https://wa.me/40771946011?text=Buna%20Mihaela.%0A%0AAs%20dori%20mai%20multe%20detalii%20despre%20sau%20despre%20programele%20tale%20online%2C%20sau%20despre%20sesiunile%20de%20Coaching%201%20la%201.';
  const emailAddress = 'contact@mihaelaiovu.ro';
  return <>
      <SharedNavbar data-id="element-895" />
      <main className="flex-grow pt-32 pb-20 md:pt-40 md:pb-28 bg-ivory min-h-screen relative overflow-hidden" data-id="element-896">
        {/* Decorative background */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-897">
          <div className="absolute top-[-10%] right-[-5%] w-[50%] h-[50%] bg-gold/10 rounded-full blur-3xl" data-id="element-898"></div>
          <div className="absolute bottom-[-10%] left-[-5%] w-[40%] h-[40%] bg-forest/5 rounded-full blur-3xl" data-id="element-899"></div>
        </div>

        <div className="max-w-[800px] mx-auto px-6 md:px-8 relative z-10" data-id="element-900">
          {/* 1. Title / Invitation */}
          <FadeIn data-id="element-901">
            <div className="text-center mb-16" data-id="element-902">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium text-forest mb-6" data-id="element-903">
                Hai să povestim
              </h1>
              <p className="text-xl text-charcoal/80 font-serif italic" data-id="element-904">
                Fiecare călătorie de transformare începe cu un prim pas.
              </p>
            </div>
          </FadeIn>

          {/* 2. Sesiune Cadou CTA */}
          <FadeIn delay={0.1} data-id="element-905">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-forest/10 mb-12 text-center relative overflow-hidden" data-id="element-906">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-full blur-2xl -z-10" data-id="element-907"></div>

              <h2 className="text-2xl font-serif text-forest mb-4" data-id="element-908">
                Programează o Sesiune Cadou
              </h2>
              <p className="text-charcoal/70 mb-8 max-w-[500px] mx-auto" data-id="element-909">
                O discuție de 30 de minute, gratuită, în care ne cunoaștem și
                vedem cum te pot susține în procesul tău.
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-910">
                <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-forest text-ivory font-display text-lg font-medium hover:bg-forest-light transition-colors w-full sm:w-auto gap-3 shadow-md shadow-forest/20" data-id="element-911">
                  <MessageCircle className="w-5 h-5" data-id="element-912" />
                  Scrie-mi pe WhatsApp
                </a>
                <a href={`mailto:${emailAddress}`} className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-ivory text-forest border border-forest/20 font-display text-lg font-medium hover:bg-forest/5 transition-colors w-full sm:w-auto gap-3" data-id="element-913">
                  <Mail className="w-5 h-5" data-id="element-914" />
                  Trimite-mi un Email
                </a>
              </div>
            </div>
          </FadeIn>

          {/* 3. Contact Details Card */}
          <FadeIn delay={0.2} data-id="element-915">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-12" data-id="element-916">
              <div className="bg-forest/5 p-8 rounded-2xl flex flex-col items-center text-center border border-forest/10" data-id="element-917">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm" data-id="element-918">
                  <Mail className="w-6 h-6 text-forest" data-id="element-919" />
                </div>
                <h3 className="font-serif text-xl text-forest mb-2" data-id="element-920">Email</h3>
                <a href={`mailto:${emailAddress}`} className="text-charcoal/80 hover:text-forest transition-colors break-all" data-id="element-921">
                  {emailAddress}
                </a>
              </div>

              <div className="bg-forest/5 p-8 rounded-2xl flex flex-col items-center text-center border border-forest/10" data-id="element-922">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm" data-id="element-923">
                  <Phone className="w-6 h-6 text-forest" data-id="element-924" />
                </div>
                <h3 className="font-serif text-xl text-forest mb-2" data-id="element-925">
                  WhatsApp
                </h3>
                <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="text-charcoal/80 hover:text-forest transition-colors" data-id="element-926">
                  +40 771 946 011
                </a>
              </div>
            </div>
          </FadeIn>

          {/* 4. Important Note */}
          <FadeIn delay={0.3} data-id="element-927">
            <div className="bg-gold/10 p-6 rounded-2xl border border-gold/20 flex items-start gap-4" data-id="element-928">
              <AlertCircle className="w-6 h-6 text-gold-dark shrink-0 mt-1" data-id="element-929" />
              <div data-id="element-930">
                <h4 className="font-serif text-lg text-forest mb-2" data-id="element-931">
                  Notă importantă
                </h4>
                <p className="text-charcoal/80 text-sm leading-relaxed" data-id="element-932">
                  Răspund la mesaje în termen de 24-48 de ore lucrătoare. Dacă
                  te afli într-o situație de criză majoră sau urgență medicală,
                  te rog să apelezi numărul de urgență 112 sau să contactezi un
                  medic specialist.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </main>
      <Footer data-id="element-933" />
    </>;
}